<template>
    <div class="flex flex-row-reverse flex-wrap sm:-mx-4 xl:mx-0 -my-4 text-center">
        <div v-for="(i, index) in count"
            :key="index"
            class="flex flex-row-reverse w-full p-4 border-t border-l border-dashed sm:w-1/2 xl:w-1/3 border-pale-grey">
            <div class="flex-shrink-0 w-116px h-116px sm:w-170px sm:h-auto">
                <div class="relative w-full h-full">
                    <div class="object-cover w-full h-116px bg-cloudy-blue opacity-50 article-loading"></div>
                </div>
            </div>

            <div class="flex-1 flex flex-col text-right justify-between pt-2 pr-4">
                <div class="w-full h-full flex flex-col justify-between">
                    <div class="w-full flex flex-col items-end">
                        <div class="w-full h-4 bg-cloudy-blue opacity-50 article-loading"></div>
                        <div class="w-1/2 h-4 bg-cloudy-blue opacity-50 article-loading mt-1"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        count: {
            type: Number,
            default: 9
        }
    }
}
</script>